import type { FC } from "react";
import { APP_KINDS, type AppKind } from "common";

const APP_KIND_LABELS: Record<AppKind, string> = {
  shiny: "Shiny",
  jupyter: "Jupyter",
  marimo: "marimo",
  rstudio: "RStudio",
  dash: "Dash",
  generic: "Generic",
};

interface AppKindSelectProps {
  value: AppKind | null | undefined;
  onChange: (value: AppKind | null) => void;
}

/** "Not set" is null, which clears the kind; the select speaks "" for it. */
const AppKindSelect: FC<AppKindSelectProps> = ({ value, onChange }) => (
  <div>
    <label
      htmlFor="app-kind"
      className="block text-sm font-medium leading-6 text-gray-900">
      App kind
    </label>
    <select
      id="app-kind"
      value={value ?? ""}
      onChange={e => onChange((e.target.value || null) as AppKind | null)}
      className="mt-2 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6">
      <option value="">Not set</option>
      {APP_KINDS.map(kind => (
        <option key={kind} value={kind}>
          {APP_KIND_LABELS[kind]}
        </option>
      ))}
    </select>
    <p className="mt-1 text-sm text-gray-500">
      Used to run the app on your own cluster.
    </p>
  </div>
);

export default AppKindSelect;
